import type { CreateRoomResponse, DeckId, RoomInfoResponse } from '@planning-session/shared';

export class ApiError extends Error {
  constructor(message: string, readonly status: number) {
    super(message);
    this.name = 'ApiError';
  }
}

async function parseError(response: Response): Promise<never> {
  const body = (await response.json().catch(() => null)) as { message?: string } | null;
  throw new ApiError(body?.message ?? `Request failed (${response.status})`, response.status);
}

export async function createRoom(deckId: DeckId): Promise<string> {
  const response = await fetch('/api/rooms', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ deckId }),
  });
  if (!response.ok) await parseError(response);

  const body = (await response.json()) as CreateRoomResponse;
  return body.roomId;
}

export async function createRetroRoom(title: string, mode: 'anonymous' | 'visible'): Promise<string> {
  const response = await fetch('/api/rooms', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ kind: 'retro', title, mode }),
  });
  if (!response.ok) await parseError(response);

  const body = (await response.json()) as CreateRoomResponse;
  return body.roomId;
}

export async function getRoomInfo(roomId: string): Promise<RoomInfoResponse | null> {
  const response = await fetch(`/api/rooms/${encodeURIComponent(roomId)}`);
  if (response.status === 404) return null;
  if (!response.ok) await parseError(response);

  return (await response.json()) as RoomInfoResponse;
}

export function socketUrl(): string {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}/ws`;
}
